

















import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { MswAppTitle } from '@/shared/msw-app-title';
import { envCongif } from '@/shared/env.config';
const cssPrefix = 'wifiPlanner';

@Component({
  components: {
    MswAppTitle,
    SwButton,
  },
})
export default class WifiPlanner extends SwExtendedVue {
  cssPrefix = cssPrefix;
  sessionId :any = JSON.parse(this.$store.getters.getUserInfo).user.sessionId;
  userId: any = this.$store.getters.getUserId;
  wifiPlannerURL: string = `${envCongif.api_url}/partnerappsToken?username=${this.userId}&appName=WIFIPLANNER&sessionID=${this.sessionId}&qsparams=`;

  launchWifiPlanner() {
    console.warn('wifi planner');
    const url = `${envCongif.api_url}/partnerappsToken?username=${this.userId}&appName=WIFIPLANNER&sessionID=${this.sessionId}&qsparams=`;
    window.open(url, '_blank');
  }
}
